<template>
	<section>
		<div class="or-queue-table-wrapper" :class="{ 'module-height': view === 'ModuleView' }">
			<b-table v-if="filteredUsers.length" table-class="or-users-table" :items="filteredUsers" :fields="fields"
				:per-page="perPage" :current-page="currentPage" striped hover bordered outlined fixed small responsive
				sort-by="pause_time" :sort-desc="true" @filtered="onFiltered">
				<template #cell(name)="data">
					<span v-if="data.item.active == 1" title="Supervisor"><i
							class="fas fa-user text-danger"></i><strong> {{
								data.item.name }}</strong></span>
					<span v-if="data.item.active == 2" title="Operador"><i class="fas fa-user text-primary"></i><strong>
							{{
								data.item.name }}</strong></span>
				</template>
				<template #cell(extension_line)="data">
					<strong>{{ data.item.extension_line }}</strong>
				</template>
				<template #cell(details)="data">
					<span class="details-icon" @click="openDetailsModal(data.item)"><i class="fas fa-eye"></i></span>
				</template>
				<template #cell(current_pause_time)="data">
					<div :key="currentTime" v-if="data.item.queues && data.item.queues.length > 0 && data.item.queues[0].status === 'paused'" class="d-flex flex-column align-items-center">
						
						<!-- <strong class="text-secondary small mb-1">{{ data.item.queues[0].pauseReason || 'Pausado' }}</strong> -->
						
						<div class="pause-timer-2" :class="getPauseColorClass(data.item.queues[0].lastPause, data.item.queues[0].pauseReason)">
							<i class="far fa-clock mr-1" :class="getPauseColorClass(data.item.queues[0].lastPause, data.item.queues[0].pauseReason, true)"></i>
							<span>{{ currentPauseToTime(data.item.queues[0].lastPause) }}</span>
						</div>
						
					</div>
					
					<div v-else class="text-muted d-flex align-items-center justify-content-center" style="height: 100%;">
						Disponível
					</div>
				</template>
				<template #cell(pause_time)="data">
					{{ getLiveTotalPauseTime(data.item) }}
				</template>
			</b-table>
			<div v-else>
				<div v-if="!reconnection" class="alert alert-warning text-center">Não há operadores em pausa</div>
				<div v-else class="alert alert-danger text-center">Reconectando ao serviço do Realtime...</div>
			</div>
		</div>
		<div class="table-footer">
			<div class="per-page-selector" v-if="view === 'ModuleView'">
				<span>Registros por página: </span>
				<select class="form-control" v-model="perPage">
					<option value="10">10</option>
					<option value="30">30</option>
					<option value="50">50</option>
					<option value="70">70</option>
					<option value="100">100</option>
				</select>
			</div>
			<b-pagination v-model="currentPage" :total-rows="totalRows"
				:per-page="view === 'ModuleView' ? perPage : filteredCalls.length" align="right" size="md"
				class="my-0"></b-pagination>
		</div>
	</section>
</template>

<script>
import Axios from 'axios';

export default {
	name: 'OrPauseTable',
	props: [
		'queueList',
		'socketClient',
		'reconnection',
		'enabledListeners',
		'view',
		'usersList',
		'queueMembers'
	],
	data() {
		return {
			fields: [
				{ key: 'name', label: 'Nome', sortable: true, 'thClass': 'or-custom-header', tdClass: ' align-content-center fw-bold' },
				{ key: 'extension_line', label: 'Ramal', sortable: true, 'thClass': 'or-custom-header small-column', tdClass: 'text-center align-content-center' },
				{ key: 'current_pause_time', label: 'Tempo em Pausa (Atual)', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center'},
				{ key: 'pause_time', label: 'Tempo Total em Pausa (Hoje)', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center' },
				{ key: 'details', label: 'Detalhes', sortable: false, 'thClass': 'or-custom-header small-column', tdClass: 'text-center align-content-center' },
			],
			perPage: this.view === 'OperatorView' ? 10 : 30,
			currentPage: 1,
			pauseTimer: null,
			pauseUpdateKey: 0,
			pausesList: [],
			currentTime: Math.floor(Date.now() / 1000),
			totalPauseTime: {}
		}
	},
	async mounted() {
		await this.loadAllPauseTimes()
	},
	computed: {
		filteredUsers() {
			this.pauseUpdateKey;
			return this.updatedUsers.filter(user => user.paused)
		},
		updatedUsers() {
			const arr = []
			this.usersList.map(el => {
				const obj = {
					...el,
					status: false,
					paused: false,
					inCall: false,
					callDuration: null,
					callNumber: null,
					callType: null,
					queues: []
				}
				arr.push(obj)
			})
			return arr
		},
		usersByExtension() {
			const map = new Map();
			this.updatedUsers.forEach(user => map.set(user.extension_line, user));
			return map;
		},
		usersById() {
			const map = new Map();
			this.updatedUsers.forEach(user => map.set(user.id, user));
			return map;
		},
		totalRows() {
			return this.updatedUsers.length
		}
	},
	methods: {
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		async enableListeners(type) {
			if (!this.socketClient) return

			if (type === 'queueMembers') {
				// Remove apenas os listeners DESTE componente
				if (this._agentPauseHandler) {
					this.socketClient.off('agentPause', this._agentPauseHandler);
				}
				if (this._agentUnpauseHandler) {
					this.socketClient.off('agentUnpause', this._agentUnpauseHandler);
				}

				if (this._agentQueueLogoffHandler) {
					this.socketClient.off('agentQueueLogoff', this._agentQueueLogoffHandler);
				}

				// Cria e armazena referências às funções
				this._agentPauseHandler = async (data) => {
					await this.handlePause(data, 'pause')
				};

				this._agentUnpauseHandler = async (data) => {
					await this.handlePause(data, 'unpause')
				};

				this._agentQueueLogoffHandler = async (data) => {
					await this.handleLogoff(data)
				};

				// Registra os novos listeners
				this.socketClient.on('agentPause', this._agentPauseHandler);
				this.socketClient.on('agentUnpause', this._agentUnpauseHandler);
				this.socketClient.on('agentQueueLogoff', this._agentQueueLogoffHandler);
			}
		},
		async handleLogoff(data) {
			const user = this.usersByExtension.get(parseInt(data.extension));

			if (!user) return;

			// *** MUDANÇA: Não remove as filas, apenas marca como deslogado ***
			if (user.queues.length) {
				const findQueue = user.queues.find(q => q.name === data.queue);

				if (findQueue) {
					// Marca a fila como deslogada mas mantém as informações de pausa
					findQueue.status = 'logged_out';
					// Remove os dados de pausa ativa, mas mantém o histórico
					delete findQueue.lastPause;
				}
			}

			// Verifica se ainda tem alguma fila realmente pausada (não logged_out)
			const hasAnyActivePausedQueue = user.queues.some(q => q.status === 'paused');

			// Se não tem mais nenhuma fila pausada ativamente, remove da lista de pausados
			if (!hasAnyActivePausedQueue) {
				user.paused = false;
			}

			// Força atualização da tabela
			this.$nextTick(() => {
				this.pauseUpdateKey++;
				this.$forceUpdate();
			});
		},
		async handlePause(data, type) {
			const user = this.usersByExtension.get(parseInt(data.extension));
			let findQueue;
			if (user) {
				if (user.queues.length) findQueue = user.queues.find(q => q.name === data.queue)

				if (type === 'pause') {
					user.paused = true;
					if (findQueue) {
						const pauseReason = !data.reason ? 'Pausa no ramal' : data.reason
						findQueue.status = 'paused'
						findQueue.pauseReason = pauseReason
						findQueue.lastPause = moment().unix()
					}
				} else {
					// *** CORREÇÃO: Só marca como não pausado se não tiver mais NENHUMA fila pausada ***
					if (findQueue) {
						findQueue.status = 'logged'
						delete findQueue.pauseReason;
						delete findQueue.lastPause;
					}

					// Verifica se ainda existe alguma outra fila pausada
					const hasOtherPausedQueues = user.queues.some(q => q.status === 'paused');

					// Só marca user.paused = false se não tiver mais nenhuma fila pausada
					if (!hasOtherPausedQueues) {
						user.paused = false;
					}
				}
				this.pauseUpdateKey++
			}
		},
		calcPauseTimer() {
            clearInterval(this.pauseTimer);
            
            this.pauseTimer = setInterval(() => {
                // PADRONIZADO: Usando apenas currentTime
                this.currentTime = Math.floor(Date.now() / 1000);

                // this.usersById.forEach((user, userId) => {
                //     if (user.paused) {
                //         if (this.totalPauseTime[userId] === undefined) {
                //             this.$set(this.totalPauseTime, userId, 0);
                //         }
                //         this.totalPauseTime[userId]++;
                //     }
                // });
            }, 1000);
        },

		getLiveTotalPauseTime(user) {
			// 1. Pega o tempo total que veio do banco (pausas já finalizadas hoje)
			let totalTime = this.totalPauseTime[user.id] || 0;

			// 2. Se ele estiver em pausa AGORA, descobre quanto tempo já passou
			if (user.paused && user.queues && user.queues.length > 0) {
				// Encontra a fila que está pausada
				const activeQueue = user.queues.find(q => q.status === 'paused');
				
				if (activeQueue && activeQueue.lastPause) {
					// Calcula os segundos da pausa atual
					const currentDuration = this.currentTime - Number(activeQueue.lastPause);
					
					if (currentDuration > 0) {
						// SOMA o tempo total antigo com o tempo da pausa atual
						totalTime += currentDuration; 
					}
				}
			}

			// 3. Manda os segundos somados para a sua função de formatar (HH:MM:SS)
			return this.secondsToTime(totalTime);
		},

        // Calcula a diferença do tempo atual e formata usando a secondsToTime
        currentPauseToTime(timestamp) {
            if (!timestamp) return '00:00:00';
            const diff = this.currentTime - Number(timestamp);
            return this.secondsToTime(diff > 0 ? diff : 0);
        },

        // Função universal de formatação (Horas:Minutos:Segundos)
        secondsToTime(seconds) {
            if (!seconds) return '00:00:00';
            const totalSecs = Math.floor(Number(seconds)) || 0;
            
            const hours = Math.floor(totalSecs / 3600);
            const minutes = Math.floor((totalSecs % 3600) / 60);
            const secs = totalSecs % 60;

            const pad = (num) => String(num).padStart(2, '0');
            return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
        },

        // Calcula a cor com base na diferença de tempo
        getPauseColorClass(timestamp, pauseReason, isIcon) {
			if (!timestamp || !pauseReason) return 'text-secondary'; 

			const seconds = this.currentTime - Number(timestamp);

			// PAUSA PARA OS DESCANSOS
			if (['Descanso 1', 'Descanso 2'].includes(pauseReason)) {
				// Acima de 10 min (600s)
				if (seconds >= 600) {
					return 'text-danger blink-anim'; 
				} 
				// Entre 6 min (360s) e 10 min
				else if (seconds >= 360) {
					return isIcon ? 'text-warning' :  'text-dark'; 
				}
				return 'text-dark';
			}

			// PAUSA PARA O LANCHE
			if (pauseReason === 'Lanche') {
				// Acima de 20 min (1200s)
				if (seconds >= 1200) {
					return 'text-danger blink-anim'; 
				} 
				// Entre 16 min (960s) e 20 min
				else if (seconds >= 960) {
					return isIcon ? 'text-warning' :  'text-dark'; 
				}
				return 'text-dark';
			}
			
			return 'text-dark';
		},
		secondsToString(unixTimestamp) {
			const now = moment();
			const pauseTime = moment.unix(unixTimestamp);
			const duration = moment.duration(now.diff(pauseTime));

			const totalMinutes = Math.floor(duration.asMinutes());

			if (totalMinutes < 1) return "Há menos de um minuto";

			if (totalMinutes < 60) {
				return `Há mais de ${totalMinutes} minuto${totalMinutes > 1 ? "s" : ""}`;
			}

			const hours = Math.floor(totalMinutes / 60);
			const remainingMinutes = totalMinutes % 60;

			if (remainingMinutes === 0) {
				return `Há mais de ${hours} hora${hours > 1 ? "s" : ""}`;
			}

			return `Há mais de ${hours} hora${hours > 1 ? "s" : ""} e ${remainingMinutes} minuto${remainingMinutes > 1 ? "s" : ""}`;
		},
		timeToSeconds(time) {
			const [hours, minutes, seconds] = time.split(':').map(num => parseInt(num, 10));
			return (hours * 3600) + (minutes * 60) + seconds;
		},
		openDetailsModal(user) {
			this.$emit('open-details-modal', { user, mode: 'view' })
		},
		async loadAllPauseTimes() {
			const { data } = await axios.get('/pauseTimeToday');
			this.totalPauseTime = data;
		}
	},
	beforeDestroy() {
		if (this.socketClient) {
			if (this._agentPauseHandler) {
				this.socketClient.off('agentPause', this._agentPauseHandler);
			}
			if (this._agentUnpauseHandler) {
				this.socketClient.off('agentUnpause', this._agentUnpauseHandler);
			}
			if (this._agentQueueLogoffHandler) {
				this.socketClient.off('agentQueueLogoff', this._agentQueueLogoffHandler);
			}
		}

		if (this.pauseTimer) clearInterval(this.pauseTimer);
	},
	watch: {
		queueMembers: {
			handler(value) {
				if (value.length) {
					value.map(el => {
						const found = this.updatedUsers.find(usr => usr.extension_line == el.extension_line)
						if (found) {
							if (!found.queues.some(q => q.name === el.queue)) found.queues.push({ name: el.queue, status: 'logged' })
							if (el.paused) {
								found.paused = true
								const pauseReason = !el.pause_reason ? 'Pausa no ramal' : el.pause_reason
								const lastPause = el.last_pause
								if (found.queues.length) {
									found.queues.map(fq => {
										if (fq.name === el.queue) {
											fq.status = 'paused'
											fq.pauseReason = pauseReason
											fq.lastPause = parseInt(lastPause)
										}
									})
								}
							}
						}
					})

					this.pauseUpdateKey++

					this.$nextTick(async () => {
						this.calcPauseTimer()
					});
				}
			},
			deep: true
		},
		"enabledListeners.queueMembers": {
			handler(value) {
				if (value) this.enableListeners('queueMembers')
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.module-height {
	height: calc(100vh - 230px) !important;
	max-height: unset !important;
}

.or-queue-table-wrapper {
	max-height: 68vh;
	overflow-y: auto;
	margin: 10px;

	::v-deep(.table-responsive) {
		border-radius: 10px 10px 0 0;
		box-shadow: 1px 1px 3px 1px #0000001f
	}

	::v-deep(.or-custom-header) {
		font-weight: bold;
		text-align: center;
		background-color: #c2b049;
		color: white;
		align-content: center;
	}

	::v-deep(.small-column) {
		width: 70px;
		text-align: center;
	}

	.icon-extension-status {
		align-self: center;
		margin-right: 5px;
	}
}

::v-deep(.page-link) {
	font-weight: bold;
	border: none;
	border-radius: 10px !important;
	padding: 5px 10px;
	transition: 0.3s;
	margin: 2px;
	background-color: transparent;

	&:hover {
		background-color: #1c859a85;
	}
}

::v-deep(.page-link) {
	font-size: smaller;
}

::v-deep(.page-link[aria-checked="true"]) {
	background-color: #c2b049;
}

::v-deep(.page-link[aria-checked="false"]) {
	color: #c2b049;
}

::v-deep(.page-link[aria-label="Go to next page"]) {
	color: #c2b049;
}

::v-deep(.page-link[aria-label="Go to previous page"]) {
	color: #c2b049;
}

::v-deep(.page-link[aria-label="Go to first page"]) {
	color: #c2b049;
}

::v-deep(.page-link[aria-label="Go to last page"]) {
	color: #c2b049;
}

.table-footer {
	display: flex;
	justify-content: space-between;
	margin: 10px;
	font-size: smaller;
	gap: 5px;
	align-items: center;

	.per-page-selector {
		display: flex;
		gap: 5px;
		white-space: nowrap;
		border-radius: 10px;
		box-shadow: 1px 1px 3px gray;
		font-weight: bold;
		padding-left: 5px;
		transition: 0.3s;
		background-color: #c2b049;
		color: white;

		span {
			align-content: center;
			font-weight: bold;
		}

		select {
			border-radius: 0 10px 10px 0 !important;
			cursor: pointer;
		}
	}
}

.bg-pause {
	background-color: #c2b049 !important;
}

.details-icon {
	font-size: medium;
	cursor: pointer;
	color: #2a95b1;

	i {
		transition: ease-in-out 0.2s;

		&:hover {
			transform: scale(1.1);
			color: #17505e
		}
	}
}

.pause-timer-2 {
    // font-size: 14px;
    color: #495057;
    display: flex;
    align-items: center;
    justify-content: center;
    // gap: 2px; /* Dá o espaço perfeito entre o ícone e o tempo */
    font-family: monospace; /* Evita que a tabela "trema" quando os números mudam */
}

/* Animação para o tempo acima de 10 minutos */
@keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0.2; }
    100% { opacity: 1; }
}

.blink-anim {
    animation: blink 1s linear infinite;
}
</style>